<template>
    <!-- Table -->
        <DeprecatedDataTable
            id="datatableAuditLog"
            label="Audit Log"
            :url="dtUrl"
            :columns="columns"
        />
</template>

<script setup>
import moment from "moment";
import { computed, defineProps, ref } from "vue";
import DeprecatedDataTable from "../../datatable/DeprecatedDataTable.vue";

moment.updateLocale("en", {
    invalidDate: "No date logged"
})

const logs = ref({});

const props = defineProps({
    user_id: {
        type: Number,
        required: true,
        default: 0
    },
});

const dtUrl = computed(() => `/api/users/${props.user_id}/audit_log/datatable`);

const columns = [
    { data: "id"},
    { data: "subject_type" },
    { data: "subject_id" },
    { data: "event" },
    { data: "properties", render: parseProperties},
    { data: "created_at"},
];

function parseProperties(data, type, row, meta) {
    return JSON.stringify(data);
}

</script>

<style scoped>

</style>
